import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon, ClockIcon, ChevronRightIcon, MapPinIcon, InfoIcon } from 'lucide-react';
import { openingHours } from '../data/businessInfo';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <>
      {/* Top Bar with Contact Info */}
      <div className="hidden lg:block bg-gradient-to-r from-[#0a0a0a] via-black to-[#0a0a0a] border-b border-white/5 py-2" data-id="element-327" data-mp="9j009l09vvov">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-12 flex justify-between items-center" data-id="element-328" data-mp="1kzgkdrmrv0i2">
          <div className="flex items-center space-x-6" data-id="element-329" data-mp="9ohm7rfu9tu5">
            <div className="flex items-center text-white/70 hover:text-white transition-colors duration-300" data-id="element-330" data-mp="9ny2c56movdh">
              <PhoneIcon size={14} className="mr-2 text-[#D6281F]" data-id="element-331" data-mp="elptuy3d2fh5" />
              <a href="tel:+31627888306" className="text-sm font-medium" data-id="element-332" data-mp="jnox87z3pce3">
                +31 (0)6 278 88 306
              </a>
            </div>
            <div className="flex items-center text-white/70 hover:text-white transition-colors duration-300" data-id="element-333" data-mp="ojnoq4fq7aiq">
              <ClockIcon size={14} className="mr-2 text-[#D6281F]" data-id="element-334" data-mp="3s2gpthrbi6w0" />
              <span className="text-sm font-medium" data-id="element-335" data-mp="3s2qi5bzu4q4v">{openingHours.short}</span>
            </div>
            <div className="flex items-center text-white/70 hover:text-white transition-colors duration-300" data-id="element-336" data-mp="ukxq5z7c5bk">
              <MapPinIcon size={14} className="mr-2 text-[#D6281F]" data-id="element-337" data-mp="5oz0itg71eq9" />
              <span className="text-sm font-medium" data-id="element-338" data-mp="34c37iiyjbmem">
                Microfoonstraat 36, Almere
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-339" data-mp="31b9tofadyy1g">
            <a href="https://www.instagram.com/bk.customs36/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-sm font-medium transition-colors duration-300 hover-underline-animation" aria-label="Instagram" data-id="element-340" data-mp="319yny9xdrg7p">
              Instagram
            </a>
            <a href="https://www.tiktok.com/@bk.customs36" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-sm font-medium transition-colors duration-300 hover-underline-animation" aria-label="TikTok" data-id="element-341" data-mp="3631dm6z1e5im">
              TikTok
            </a>
          </div>
        </div>
      </div>
      {/* Main Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/90 backdrop-blur-xl py-3 shadow-2xl border-b border-[#222]' : 'bg-transparent py-5 lg:mt-10'}`} data-id="element-342" data-mp="2s88qamcwnl1h">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-12" data-id="element-343" data-mp="2l9msvwmzrm0">
          <div className="flex items-center justify-between" data-id="element-344" data-mp="2kzwf77ojifs">
            {/* Logo */}
            <Link to="/" className="relative z-10 flex-shrink-0 group" data-id="element-345" data-mp="a37i9whzh268">
              <div className="overflow-hidden rounded-sm bg-gradient-to-br from-black to-[#0a0a0a] p-1 shadow-2xl border border-white/5" data-id="element-346" data-mp="f459szovv8ke">
                <div className="relative flex items-center" data-id="element-347" data-mp="15x5g6pip4z7">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6P9doWbYb8UgxtfPvK6o5M/BK-Customs-Logo-DEF-01-1973x2048.png" alt="BKCustoms Logo" className="h-16 w-auto transition-transform duration-500 group-hover:scale-105" data-id="element-348" data-mp="54xp1rftkbn9" />
                  <div className="ml-3 hidden lg:block border-l border-white/10 pl-3" data-id="element-349" data-mp="xtlg63n91v8q">
                    <div className="text-xs uppercase tracking-widest text-white/70" data-id="element-350" data-mp="k2gj99b9nh23">
                      AUTO STYLING ALMERE
                    </div>
                    <div className="text-sm font-semibold tracking-wide text-white" data-id="element-351" data-mp="1btmebbc4qoki">
                      BKCustoms{' '}
                      <span className="text-[#D6281F]" data-id="element-352" data-mp="1glw9b5s3qetn">since 2020</span>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#D6281F]/0 via-white/10 to-[#D6281F]/0 opacity-0 group-hover:opacity-100 -translate-x-full group-hover:translate-x-full transition-all duration-1000 ease-in-out" data-id="element-353" data-mp="3p3i7cu8s697i"></div>
                </div>
              </div>
            </Link>
            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center" data-id="element-354" data-mp="bn0zttq80gw8">
              <div className="bg-[#0a0a0a]/80 backdrop-blur-sm border border-white/5 rounded-full py-2 px-1 mr-6" data-id="element-355" data-mp="bmizakwizgii">
                <ul className="flex items-center space-x-1" data-id="element-356" data-mp="6q0ujl173i66">
                  {[{
                  name: 'HOME',
                  href: '/'
                }, {
                  name: 'DIENSTEN',
                  href: '/diensten'
                }, {
                  name: 'OVER ONS',
                  href: '/over-ons'
                }, {
                  name: 'PORTFOLIO',
                  href: '/#portfolio'
                }, {
                  name: 'REVIEWS',
                  href: 'https://www.google.com/search?sxsrf=AE3TifNiNevh4m__DdaKWERCMdH24XpRtg:1754766584748&uds=AOm0WdE2fekQnsyfYEw8JPYozOKz0wcvbhHSVFg8j-5t32_cmw-uZHH1Ie0ViIzu2Ih2Lf2im8v8fY1Ho2TGkJfJRJpAGhY55Xpv1IbzirtlLVC2Vh8ZGmLH0P_oWVzAAxnUGFjdyEzDGqU8E6Wv5m5gwuUD1jNCdQ&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EznTpCXA5n6GCKlFSNsSFTRFdddxfZT0txeh7NrTgp9y_tTxUR9AZDv4TVb9CBJAr3216lk%3D&q=Bk+Customs+Reviews',
                  external: true
                }].map(item => <li key={item.name} data-id="element-357" data-mp="2w6pkv1xm74nr">
                      {item.external ? <a href={item.href} target="_blank" rel="noopener noreferrer" className="relative group px-4 py-2 block rounded-full hover:bg-white/5 transition-colors duration-300" data-id="element-358" data-mp="2w563t944wpkx">
                          <span className="relative z-10 text-white text-sm font-semibold tracking-wide transition-colors duration-300 group-hover:text-[#D6281F]" data-id="element-359" data-mp="351ne6a4ocjfm">
                            {item.name}
                          </span>
                        </a> : <Link to={item.href} className="relative group px-4 py-2 block rounded-full hover:bg-white/5 transition-colors duration-300" data-id="element-360" data-mp="1euzcf2deidev">
                          <span className="relative z-10 text-white text-sm font-semibold tracking-wide transition-colors duration-300 group-hover:text-[#D6281F]" data-id="element-361" data-mp="19ul37h02cxf9">
                            {item.name}
                          </span>
                        </Link>}
                    </li>)}
                </ul>
              </div>
              {/* Refined CTA Button - Less Bold */}
              <Link to="/afspraak-maken" className="relative overflow-hidden group" data-id="element-362" data-mp="1tkdl0895kqt7">
                <div className="absolute inset-0 bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] rounded-md opacity-80 animate-gradient-shift" data-id="element-363" data-mp="27j3ktvncx4l9"></div>
                <div className="relative flex items-center justify-center px-6 py-3 rounded-md" data-id="element-364" data-mp="d65d9jt1km1m">
                  <span className="text-black font-medium tracking-wide uppercase mr-2 transition-all duration-300 group-hover:translate-x-[-2px] text-sm" data-id="element-365" data-mp="87k959ao5i7w">
                    Afspraak maken
                  </span>
                  <ChevronRightIcon size={14} className="text-black transition-all duration-300 group-hover:translate-x-1" data-id="element-366" data-mp="2ou0en5u05k2a" />
                </div>
              </Link>
            </div>
            {/* Mobile Menu Button */}
            <div className="lg:hidden" data-id="element-367" data-mp="2f2mhh4piwwcb">
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="relative p-2 overflow-hidden group" aria-expanded={isMenuOpen} data-id="element-368" data-mp="2f1kyme29n5k1">
                <div className="absolute inset-0 bg-[#D6281F]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-sm" data-id="element-369" data-mp="264ajghmbuw9u"></div>
                <div className="relative z-10" data-id="element-370" data-mp="1r8crzcncmg3y">
                  {isMenuOpen ? <XIcon size={24} className="text-white" data-id="element-371" data-mp="1w5utihz1dt1x" /> : <MenuIcon size={24} className="text-white" data-id="element-372" data-mp="3ljzwxrzyfwy2" />}
                </div>
              </button>
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        {isMenuOpen && <div className="lg:hidden bg-black/95 backdrop-blur-xl animate-fadeIn" data-id="element-373" data-mp="3qgqb29s78igu">
            <div className="px-6 pt-6 pb-8 divide-y divide-white/10" data-id="element-374" data-mp="2ebtum6b00vkl">
              <div className="pb-6 space-y-4" data-id="element-375" data-mp="29bz4i4z1sa0l">
                {[{
              name: 'HOME',
              path: '/',
              external: false
            }, {
              name: 'DIENSTEN',
              path: '/diensten',
              external: false
            }, {
              name: 'OVER ONS',
              path: '/over-ons',
              external: false
            }, {
              name: 'PORTFOLIO',
              path: '/#portfolio',
              external: false
            }, {
              name: 'REVIEWS',
              path: 'https://www.google.com/search?sxsrf=AE3TifNiNevh4m__DdaKWERCMdH24XpRtg:1754766584748&uds=AOm0WdE2fekQnsyfYEw8JPYozOKz0wcvbhHSVFg8j-5t32_cmw-uZHH1Ie0ViIzu2Ih2Lf2im8v8fY1Ho2TGkJfJRJpAGhY55Xpv1IbzirtlLVC2Vh8ZGmLH0P_oWVzAAxnUGFjdyEzDGqU8E6Wv5m5gwuUD1jNCdQ&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EznTpCXA5n6GCKlFSNsSFTRFdddxfZT0txeh7NrTgp9y_tTxUR9AZDv4TVb9CBJAr3216lk%3D&q=Bk+Customs+Reviews',
              external: true
            }].map(item => item.external ? <a key={item.name} href={item.path} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between text-white py-2 border-b border-white/10 hover:text-[#D6281F] transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-376" data-mp="3nh12vn4jnkva">
                      <span className="text-base font-medium" data-id="element-377" data-mp="2zlq2prp9mk5q">{item.name}</span>
                      <ChevronRightIcon size={16} data-id="element-378" data-mp="34j832tp7vr24" />
                    </a> : <Link key={item.name} to={item.path} className="flex items-center justify-between text-white py-2 border-b border-white/10 hover:text-[#D6281F] transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-379" data-mp="34luamtc3y6kc">
                      <span className="text-base font-medium" data-id="element-380" data-mp="ot52mtg2vrjt">{item.name}</span>
                      <ChevronRightIcon size={16} data-id="element-381" data-mp="troqize8fdet" />
                    </Link>)}
              </div>
              <div className="pt-6 space-y-4" data-id="element-382" data-mp="ttj947216tfq">
                <div className="flex items-center text-white/70" data-id="element-383" data-mp="cw3qh7leo6el">
                  <PhoneIcon size={16} className="mr-3 text-[#D6281F]" data-id="element-384" data-mp="gyi8jph9324t" />
                  <a href="tel:+31627888306" className="text-sm hover:text-white transition-colors duration-300" data-id="element-385" data-mp="gwnmu8y5n5zo">
                    +31 (0)6 278 88 306
                  </a>
                </div>
                <div className="flex items-center text-white/70" data-id="element-386" data-mp="qqnuahgwsnbk">
                  <ClockIcon size={16} className="mr-3 text-[#D6281F]" data-id="element-387" data-mp="3q4zyzq4v8j9q" />
                  <span className="text-sm" data-id="element-388" data-mp="3u4qpdsqhcxdq">{openingHours.short}</span>
                </div>
                <div className="flex items-center text-white/70" data-id="element-389" data-mp="2yft09wf0ksq">
                  <MapPinIcon size={16} className="mr-3 text-[#D6281F]" data-id="element-390" data-mp="31bqjx4cp7gn" />
                  <span className="text-sm" data-id="element-391" data-mp="7zmyg2b357w8">Microfoonstraat 36, Almere</span>
                </div>
                {/* Refined Mobile CTA Button */}
                <Link to="/afspraak-maken" className="block relative overflow-hidden mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-392" data-mp="1jcyxlzvwh2c2">
                  <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] animate-gradient-shift px-6 py-3 text-center font-medium uppercase tracking-wide text-black rounded-md opacity-90" data-id="element-393" data-mp="33u83rigtjvte">
                    Afspraak maken
                  </div>
                </Link>
              </div>
            </div>
          </div>}
      </nav>
    </>;
};